import { useContext } from "react";
import GlobalContext from "@context/GlobalContext";
import UtilServices from "@services/UtilServices";
import { useNavigate } from "react-router-dom";

export default function useAutenticar() {
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();

  //Função auxiliar para verificar e atualizar estado
  function handleVerificar(key, actionType) {
    let value = state[key];
    let resultado = false;

    //Verifica se o state é nulo
    if (value.length === 0) {
      value = UtilServices.getStorage(key);
      //Verifica se storage é nulo
      if (value.length !== 0) {
        dispatch({
          type: actionType,
          payload: value,
        });
        resultado = true;
      }
    } else {
      resultado = true;
    }

    return resultado;
  }

  //Autenticação 2 etapas
  function handleAutenticar() {
    // Etapa 1: Verificar dados do usuário
    const etapa1 = handleVerificar("dadosusuario", "SET_USUARIO");
    if (!etapa1) {
      console.error("Erro na validação dos dados do usuário.");
      return false;
    }

    // Etapa 2: Verificar e setar permissões do usuário caso ele tiver.
    handleVerificar("permissoesusuario", "SET_PERMISSOES");

    // Etapa 2.1: Verificar e seta o perfil selecionado.
    handleVerificar("perfilselecionado", "SET_PERFILSELECIONADO");

    // Etapa 3: Verificar token
    const etapa3 = UtilServices.verificarToken();
    if (!etapa3) {
      console.error("Token inválido ou expirado.");
      return false;
    }

    // Etapa 4: Verificar e seta o perfil selecionado.
    handleVerificar("notificacao", "SET_NOTIFICACAO");

    // Todas as etapas passaram
    console.log("Validação concluída com sucesso.");
    return true;
  }

  // Remover os estados globais
  function handleLogout() {
    dispatch({
      type: "SET_RESET",
    });
    UtilServices.clearStorage();
    navigate("/");
  }

  return { handleAutenticar, handleLogout };
}
